import { ShowroomMatCardViewModel } from "./showroom-mat-card/showroom-mat-card.view-model";

export class ShowroomViewModel {

	public showroomMatCardViewModels: ShowroomMatCardViewModel[];

}
